import { Badge } from "@/components/common";

/** Whole days from today to a "YYYY-MM-DD" date (negative once it has passed). */
export function daysUntil(day: string) {
  const target = new Date(`${day}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / 86_400_000);
}

export function ExamDateBadge({ examDate }: { examDate: string | null }) {
  if (!examDate) {
    return <Badge variant="warning">termin nieznany</Badge>;
  }
  const days = daysUntil(examDate);
  if (days < 0) {
    return <Badge>odbył się</Badge>;
  }
  if (days === 0) {
    return <Badge variant="error">dziś</Badge>;
  }
  return (
    <Badge variant={days <= 7 ? "error" : "info"}>
      {days === 1 ? "jutro" : `za ${days} dni`}
    </Badge>
  );
}
